import { useEffect, useMemo, useState } from 'react';

interface UseBettieIntroAnimationOptions {
  titleDelayMs?: number;
  descriptionDelayMs?: number;
  moveDelayMs?: number;
  hideDelayMs?: number;
  fadeDurationMs?: number;
}

export function useBettieIntroAnimation(
  isFirst: boolean,
  {
    titleDelayMs = 0,
    descriptionDelayMs = 500,
    moveDelayMs = 1000,
    hideDelayMs = 2000,
    fadeDurationMs = 1000
  }: UseBettieIntroAnimationOptions = {}
) {
  // Overlay mount / keyframe states
  const [showIntro, setShowIntro] = useState<boolean>(isFirst);
  const [showBettieTitle, setShowBettieTitle] = useState<boolean>(false);
  const [showDescription, setShowDescription] = useState<boolean>(false);
  const [moveToTop, setMoveToTop] = useState<boolean>(false);
  // Cross-fade states
  const [overlayFadingOut, setOverlayFadingOut] = useState<boolean>(false);
  const [revealBaseContent, setRevealBaseContent] = useState<boolean>(!isFirst);

  const fadeStyle = useMemo(
    () => ({
      fadeDurationMs
    }),
    [fadeDurationMs]
  );

  useEffect(() => {
    if (!isFirst) {
      // 바로 기본 화면 노출, 오버레이 미사용
      setShowIntro(false);
      setRevealBaseContent(true);
      return;
    }

    // 타임라인: 타이틀 → 설명 → 위로 이동 → 페이드 아웃 + 베이스 페이드 인
    const t1 = setTimeout(() => setShowBettieTitle(true), titleDelayMs);
    const t2 = setTimeout(() => setShowDescription(true), descriptionDelayMs);
    const t3 = setTimeout(() => setMoveToTop(true), moveDelayMs);
    const t4 = setTimeout(() => {
      setOverlayFadingOut(true);
      setRevealBaseContent(true);
    }, hideDelayMs);
    const t5 = setTimeout(() => {
      setShowIntro(false);
    }, hideDelayMs + fadeDurationMs);

    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
      clearTimeout(t4);
      clearTimeout(t5);
    };
  }, [isFirst, titleDelayMs, descriptionDelayMs, moveDelayMs, hideDelayMs, fadeDurationMs]);

  return {
    // mount / animation cues
    showIntro,
    showBettieTitle,
    showDescription,
    moveToTop,
    // cross-fade cues
    overlayFadingOut,
    revealBaseContent,
    fadeStyle
  };
}
